<script>
  export default {
    name: 'HimekuriFinish'
  }
</script>

<template lang="pug">
  .himekuri-finish
    img.himekuri-finish__img(
      src = '~@/assets/img/modal_ribbon_finish.svg'
      )
    .himekuri-finish__text
      |これからも住友生命「Vitality」を
      br.brNoto
      |お楽しみください。
</template>

<style lang="scss">
  .himekuri-finish {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    text-align: center;
    &__img {
      width: 274px;
      height: 114px;
      display: block;
      margin-bottom: 10px;
    }
    &__heading {
      line-height: (26 / 20);
      margin-bottom: 10px;
      color: $primary-color;
      @include fontSize(20);
      font-weight: 700;
    }
    &__text {
      line-height: (22 / 16);
      @include fontSize(16);
    }
  }
</style>
